import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,TableContainer,
      Paper,
    TableBody, Checkbox,
    TableCell, FormControlLabel,
} from "@material-ui/core";
import { saveAs } from 'file-saver';
import { Card, Box } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import StudentService from "./Locality/Service/studentService"
import SuperActivityService from "./Locality/Service/superActivityService"
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import LanguageIcon from '@material-ui/icons/Language';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import HistoryIcon from '@material-ui/icons/History';
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import ExportExcel from "../../Excelexport";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function StudentActivity() {
    const tableHeaders = ['Class', 'Area Of Work', 'List Of Activities', 'Exercises', 'Remarks',
        'Key', 'Start Date', 'End Date', 'Edit', 'Delete', 'Add More', 'History', 'Public Status'];
    const classes = useStyles();
    const [openHistory, setOpenHistory] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState([]);
    const [activityListcount, setActivityListcount] = useState({});
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [checkedActivities, setCheckedActivities] = useState([]);
    const [selectedActivityMap, setSelectedActivityMap] = useState({});  // Store relationships between sub-activities and their parents
    const [checkedSubActivities, setCheckedSubActivities] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [activityList, setActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [subActivityList, setSubActivityList] = useState([]);
    const [studentReportList, setStudentReportList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [activityIdList, setActivityIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isAdd, setIsAdd] = React.useState(false);
    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [result, setResult] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [studentReportResult, setStudentReportResult] = useState([]);
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const today = new Date();
    const [keyList, setKeyList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const keyOptions = [
        { label: 'Presented(1)', value: 'P' },
        { label: 'Works Independently(2)', value: 'WI' },
        { label: 'Works with Assistance(3)', value: 'WA' },
        { label: 'Mastered(4)', value: 'M' }
    ];
    const getWeekStartEnd = (date) => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        const endOfWeek = new Date(date);
        endOfWeek.setDate(endOfWeek.getDate() + (5 - endOfWeek.getDay()));

        let startDay = startOfWeek.getDate();
        let startMonth = startOfWeek.getMonth() + 1;
        let startYear = startOfWeek.getFullYear();
        if (startDay < 10) {
            startDay = '0' + startDay;
        }

        if (startMonth < 10) {
            startMonth = `0${startMonth}`;
        }
        let format = startYear + "-" + startMonth + "-" + startDay;

        let endDay = endOfWeek.getDate();
        let endMonth = endOfWeek.getMonth() + 1;
        let endYear = endOfWeek.getFullYear();
        if (endDay < 10) {
            endDay = '0' + endDay;
        }

        if (endMonth < 10) {
            endMonth = `0${endMonth}`;
        }

        let format1 = endYear + "-" + endMonth + "-" + endDay;

        return { start: format, end: format1 };
    }
    const date = new Date();
    const week = getWeekStartEnd(date);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const year = today.getFullYear();

    const [activity, setActivity] = useState({
        classId: '',
        // date: new Date().toISOString().split("T")[0],
        // studentId: '',
        studentId: [],
        superActivityId: '',
        activityId: '',
        subActivityId: '',
        key: '',
        remarks: '',
        // planning: '',
        isEdit: false,
        endDate: '',
        date: '',
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const verifyeetnt = () => {
        console.log(formik)
    }
    const formRefs = {
        date: React.useRef(),
        endDate: React.useRef(),
        classId: React.useRef(),
        studentId: React.useRef(),
        remarks: React.useRef()
    };
    const filterTreeNode = (node) => {
        if (searchTerm === "") return true;
        const term = searchTerm.toLowerCase();

        // Check if current node matches
        if (node.superActivityName?.toLowerCase().includes(term) ||
            node.activityName?.toLowerCase().includes(term) ||
            node.subActivityName?.toLowerCase().includes(term)) {
            return true;
        }

        // Check children (activities)
        if (node.activities?.some(activity =>
            activity.activityName?.toLowerCase().includes(term) ||
            activity.subActivities?.some(sub =>
                sub.subActivityName?.toLowerCase().includes(term)
            )
        )) {
            return true;
        }

        // Check sub-activities
        if (node.subActivities?.some(sub =>
            sub.subActivityName?.toLowerCase().includes(term)
        )) {
            return true;
        }

        return false;
    };
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const getAllSuperActivityTabelMultiple = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityTabelMultiple(getsupActList).then((res) => {

            setSelectedActivities(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };

    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };
    // classId: Yup.string().required('Class Name is required'),

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
       // date: Yup.string(new Date().toISOString().split("T")[0]).required('Date is required'),
        studentId: Yup.array(),
        activityId: Yup.string(),
        subActivityId: Yup.string(),
        key: Yup.string(),
        // academicYear:Yup.string(),
        remarks: Yup.string(),
        planning: Yup.string(),
        //date: Yup.string().nullable(),
        isEdit: Yup.boolean(),
        date: Yup.string().required('date is required'),
        endDate: Yup.string().required('date is required'),
    });
    useEffect(() => {
        // Set initial dates to current week's start and end
        setStartDate1(week.start);
        setEndDate1(week.end);
        
        //getActivityList();
        onSubmit();
        // getStudentActivityList();

        getAddClassList();
        //  getSuperActivityList();
        return () => {
            setSubActivityList([]);
            setActivityIdList([]);
            setActivityList([]);
            setAddClassList([]);
            setStudentList([]);
            setAddSuperActivityList([]);
            setStudentReportList([]);
        }
    }, []);
    // useEffect(() => {
    //     //getActivityList();
    //     onSubmit();
    //     // getStudentActivityList();

    //     getAddClassList();
    //     //  getSuperActivityList();
    //     return () => {
    //         setSubActivityList([]);
    //         setActivityIdList([]);
    //         setActivityList([]);
    //         setStudentList([]);
    //         setAddSuperActivityList([]);
    //         setStudentReportList([]);
    //     }
    // }, []);
    
    const formik = useFormik({
        initialValues: activity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.authorizedPerson = userDetails.email
            values.isFuturePlanning = false
            values.studentId = values.studentId
                values.activityRelationships = selectedActivityMap;

            if (activity._id) {
                ActivityService.upadeActivity(values).then((res) => {
                    handleClose();
                    // getActivityList();
                    onSubmit()
                    resetForm()
                    alert("Activity Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                let currentYear = new Date().getFullYear();
                let nextYear = new Date().getFullYear() + 1;
                console.log(currentYear + "-" + nextYear);
                values['academicYear'] = currentYear + "-" + nextYear;
                values.subActivityId = values.subActivityId ? values.subActivityId : null;
                values.date = values.date ? values.date : new Date().toISOString().split("T")[0];
                ActivityService.creteMultipleActivity(values).then((res) => {

                    // getActivityList();
                    onSubmit()
                    resetForm();
                    handleClose();
                    alert(" Activity Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {

                        alert(err.response.data.message)
                    })
            }

        },
    });
    const renderTree = (node) => {
        // Don't render if it doesn't match the search
        if (!filterTreeNode(node)) return null;
        const superActivitId = node._id;
        // Super Activity node
        if (node.superActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    // label={node.superActivityName}
                    label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <LanguageIcon style={{ marginRight: 8, color: "#4caf50" }} />
                            {node.superActivityName}
                        </div>
                    }
                    onClick={(e) => e.stopPropagation()}
                >
                    {Array.isArray(node.activities) && node.activities.map(renderTree)}
                </TreeItem>
            );
        }
        // Activity node
        if (node.activityName) {
            const hasSubActivities = Array.isArray(node.subActivities) && node.subActivities.length > 0;
            const subActivityIds = hasSubActivities ? node.subActivities.map(sub => sub._id) : [];

            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setCheckedActivities(prev => [...prev, node._id]);
                                        // If there are no subActivities, treat the activity itself as a selectable item
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => ({
                                                ...prev,
                                                [node._id]: {
                                                    activityId: node._id,
                                                    superActivityId: node.superActivityId,
                                                    isChild: false
                                                    // No subActivityId since this is the activity itself
                                                }
                                            }));
                                        }
                                    } else {
                                        setCheckedActivities(prev => prev.filter(id => id !== node._id));
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => {
                                                const newMap = { ...prev };
                                                delete newMap[node._id];
                                                return newMap;
                                            });
                                        }
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.activityName}</span>
                        </div>
                    }
                >
                    {hasSubActivities && node.subActivities.map(sub =>
                        renderTree({ ...sub, parentActivityId: node._id, superActivityId: node.superActivityId, isChild: true })
                    )}
                </TreeItem>
            );
        }
        // SubActivity node
        if (node.subActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedSubActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        // Check sub-activity
                                        setCheckedSubActivities(prev => [...prev, node._id]);
                                        // Check parent activity if not already checked
                                        if (!checkedActivities.includes(node.parentActivityId)) {
                                            setCheckedActivities(prev => [...prev, node.parentActivityId]);
                                        }
                                        // Store the relationship
                                        setSelectedActivityMap(prev => ({
                                            ...prev,
                                            [node._id]: {
                                                subActivityId: node._id,
                                                activityId: node.parentActivityId,
                                                superActivityId: node.superActivityId,
                                                isChild: true
                                            }
                                        }));
                                    } else {
                                        // Just uncheck the sub-activity
                                        setCheckedSubActivities(prev => prev.filter(id => id !== node._id));
                                        // Remove the relationship
                                        setSelectedActivityMap(prev => {
                                            const newMap = { ...prev };
                                            delete newMap[node._id];
                                            return newMap;
                                        });
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.subActivityName}</span>
                        </div>
                    }
                />
            );
        }
        return null;
    };
    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId ? item.studentId._id : "";

            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {

            setAddSuperActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (isAdd) => {
        setOpen(true);
        if (isAdd) {
            setActivity({
                classId: '',
                // date: new Date().toISOString().split("T")[0],
                // studentId: '',
                studentId: [],
                superActivityId: '',
                activityId: '',
                subActivityId: '',
                key: '',
                remarks: '',
                // planning: '',
                isEdit: false,
                endDate: '',
                sfd: '',
            });
        }
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);

            // ✅ Auto-select first class (especially for TEACHER)
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                getStudentList({ target: { value: userDetails.classId } });
            } else {
                setClassId(""); // No default selection
            }
        }).catch((err) => {
            // handle error here if needed
        });
    };
    const excelExport = (res) => {
        const result = [];
        res.forEach((group) => {
            const studentName = group.studentId
                ? `${group.studentId.firstName} ${group.studentId.lastName}`
                : '';
            const className = group.classId?.className || '';

            group.activityRecordsId.forEach((activity) => {
                result.push({
                    "Student Name": studentName,
                    "Class Name": className,
                    "Area Of Work": activity.superActivityId?.superActivityName || '',
                    "List Of Activities": activity.activityId?.activityName || '',
                    "Exercise": activity.subActivityId?.subActivityName || '',
                    "Remarks": activity.remarks || '',
                    "Key": activity.key,
                    "Date": activity.date || '',
                });
            });
        });
        console.log(result)
        setResult(result);
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : "";
        const newendDate1 = endDate1 ? endDate1 : "";
        if (studentId == '') {
            alert("Please Select Student");
            return;
        }
        const getstudentId = { "studentId": studentId, "startDate1": newstartDate1, "endDate1": newendDate1 };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            alert(err.response.data.message)
        });
    }
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate = startDate1 ? startDate1 : week.start;
        const newendDate = endDate1 ? endDate1 : week.end;

        const keys = { "schooleId": userDetails.schooleId, "isFuturePlanning": false, "studentId": studentId, 'classId': classId, "startDate1": newstartDate, "endDate1": newendDate, "status": true, }
        ActivityService.findActivityList(keys).then((res) => {
            excelExport(res);
            // setClassValue("");
            setActivityList(res);
            // setStudentList(res);
        }).catch((err) => {
            // setError(err.message);
        });

    };
    
    const getSubActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            activityId: event.target.value
        };
        SubActivityService.getAllSubActivityByActivityId(getsubActList).then((res) => {
            setSubActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    
    const getActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            superActivityId: event.target.value
        };

        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            setAddActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getStuList = { classId: event.target.value };


        StudentService.getAllStudentById(userDetails.schooleId, getStuList
        ).then((res) => {
            let studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });

            setStudentList(studentDetails);

            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }


    const getStudentActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getStudentActivity(userDetails.schooleId, false).then((res) => {
            setActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }


    const editActivity = (useractivitys, status) => {
        debugger
        const obj = JSON.parse(JSON.stringify(useractivitys, status));
        obj.classId = useractivitys.classId ? useractivitys.classId._id : '';

        obj.studentId = Array.isArray(useractivitys.studentId)
            ? useractivitys.studentId.map(student => student._id)
            : [useractivitys.studentId]

        obj.superActivityId = useractivitys.superActivityId ? useractivitys.superActivityId._id : '';
        obj.activityId = useractivitys.activityId ? useractivitys.activityId._id : '';
        obj.subActivityId = useractivitys.subActivityId ? useractivitys.subActivityId._id : '';
        obj.isEdit = true;
        getSuperActivityList({ target: { value: obj.classId } }, obj);
        getStudentList({ target: { value: obj.classId } }, obj);
        getSubActivityList({ target: { value: obj.activityId } }, obj);
        getActivityList({ target: { value: obj.superActivityId } }, obj);
        getAddClassList({ target: { value: obj.superActivityId } }, obj)
        //getStudentActivityList(useractivitys.classId);
        if (status) {
            delete obj._id;
        }
        obj.isEdit = true;
        setActivity(obj);
        handleOpen()
    }

    const deleteActivity = (activitydelete) => {
        if (activitydelete) {
            ActivityService.deleteActivity(activitydelete).then((res) => {

                onSubmit()
            }).catch((err) => {
            });
        }
    };
    const handlePublicStatusClick = (activity) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getStatus = {
            publicStatus: "publish",
            _id: activity._id

        };
        ActivityService.upadePublicStatus(getStatus).then((res) => {
            alert('Reports published succesfully')
            activity.publicStatus = "publish";
            getStudentActivityList();

        }).catch((err) => {
            // setError(err.message);
        });
    }


    return (

        <>
            <PageTitle title="Activity Planner" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />

            <Card sx={{ maxWidth: 345 }}>
                <Box style={{ margin: 15, }} >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={6} sm={6} md={2}  >
                            <FormControl className={classes.formControl} style={{ width: 170 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"


                                    onChange={e => { setClassId(e.target.value); getStudentList(e) }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={6} sm={6} md={2}  >
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <form className={classes.container} noValidate>
                                <TextField InputProps={{ style: { width: 140 } }}
                                    id="dob"
                                    name="dob"
                                    label="Start Date"
                                    type="date"
                                    min="2016-11-10"
                                    max="2022-11-10"
                                    value={startDate1}
                                    onChange={e => { 
                                        setStartDate1(e.target.value);
                                        // If end date is before new start date, clear it
                                        if (endDate1 && e.target.value && new Date(e.target.value) > new Date(endDate1)) {
                                            setEndDate1('');
                                        }
                                    }}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </form>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <TextField InputProps={{ style: { width: 140 } }}
                                id="dob"
                                name="dob"
                                label="End Date"
                                type="date"
                                min={startDate1 || "2016-11-10"}
                                max="2022-11-10"
                                value={endDate1}
                                onChange={e => { 
                                    const selectedEndDate = e.target.value;
                                    // Only allow if end date is greater than or equal to start date
                                    if (!startDate1 || new Date(selectedEndDate) >= new Date(startDate1)) {
                                        setEndDate1(selectedEndDate);
                                    } else {
                                        // Show error or prevent selection
                                        alert('End date must be greater than or equal to start date');
                                    }
                                }}
                                error={endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1)}
                                helperText={endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1) ? 'End date must be >= start date' : ''}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"

                                onClick={() => onSubmit()} variant="contained"
                            >
                                Search</Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <ExportExcel style={{ fontSize: "11px", }} excelData={result} fileName={'Activity recorder'} />
                        </Grid>
                    </Grid>
                    {/* <Grid container spacing={2} columns={12}   >


                        <Grid item xs={6} sm={6} md={2} >
                            <ExportExcel style={{ fontSize: "11px", }} excelData={result} fileName={'Activity recorder'} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', fontSize: '13px' }} type="button" onClick={() => getStudentReportList()} >student report</Button>
                        </Grid>
                    </Grid> */}


                </Box>
            </Card>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {activityList
                                    .slice(pg * rpg, pg * rpg + rpg) // Pagination logic
                                    .map((group) => (
                                          group.activityRecordsId.length > 0 && (
                                        <React.Fragment key={group.studentId?._id}>
                                            <TableRow>
                                                <TableCell className="pl-3 fw-bold" colSpan={tableHeaders.length} style={{ backgroundColor: '#7f8582', color: '#ffff', 'font-size': '17px', 'font-weight': '500' }}>
                                                    {group.studentId?.firstName} {group.studentId?.lastName}
                                                </TableCell>
                                            </TableRow>
                                            {group.activityRecordsId.map((activity) => (
                                                <TableRow key={activity._id}>

                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.classId ? activity.classId.className : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.superActivityId ? activity.superActivityId.superActivityName : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.activityId ? activity.activityId.activityName : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.subActivityId ? activity.subActivityId.subActivityName : ""}
                                                    </TableCell>

                                                    {/* <TableCell className="pl-3 fw-normal">
                                        {activity.authorizedPerson}
                                    </TableCell> */}
                                                    <TableCell className="pl-3 fw-normal">{activity.remarks}</TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.key === 'P'
                                                            ? 'Presented'
                                                            : activity.key === 'WI'
                                                                ? 'Work Independently'
                                                                : activity.key === 'WA'
                                                                    ? 'Work with Assistance'
                                                                    : activity.key === 'M'
                                                                        ? 'Mastered'
                                                                        : activity.key}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">{activity.date}</TableCell>

                                                    <TableCell className="pl-3 fw-normal">{activity.endDate}</TableCell>                                                    <TableCell>
                                                        <EditIcon style={{ cursor: "pointer" }} onClick={() => editActivity(activity, false)} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <DeleteIcon style={{ cursor: "pointer" }} onClick={() => deleteActivity(activity._id)} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <AddIcon style={{ cursor: "pointer" }} onClick={() => editActivity(activity, true)} />
                                                    </TableCell>
                                                    {/* <TableCell className="pl-3 fw-normal">
                                                        <div style={{ maxHeight: '120px', overflowY: 'auto', padding: '4px' }}>
                                                            {group.activityRecordsId
                                                                .filter(record => record.activityId?._id === activity.activityId?._id)
                                                                .map((record, idx) => (
                                                                    <div key={idx} style={{ marginBottom: '8px' }}>
                                                                        <strong>
                                                                            {record.key === 'P' ? 'Presented'
                                                                                : record.key === 'WI' ? 'Work Independently'
                                                                                    : record.key === 'WA' ? 'Work with Assistance'
                                                                                        : record.key === 'M' ? 'Master'
                                                                                            : record.key}
                                                                        </strong>
                                                                        <br />
                                                                        {Array.isArray(record.statusHistory) && record.statusHistory.length > 0 ? (
                                                                            record.statusHistory
                                                                                .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt))
                                                                                .map((history, hIdx) => (
                                                                                    <div
                                                                                        key={hIdx}
                                                                                        style={{
                                                                                            background: '#f0f4f8',
                                                                                            borderRadius: '6px',
                                                                                            padding: '6px 8px',
                                                                                            marginTop: '4px',
                                                                                            fontSize: '0.85rem',
                                                                                            color: '#333',
                                                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                                                        }}
                                                                                    >
                                                                                        <strong>
                                                                                            {history.key === 'P' ? 'Presented'
                                                                                                : history.key === 'WI' ? 'Work Independently'
                                                                                                    : history.key === 'WA' ? 'Work with Assistance'
                                                                                                        : history.key === 'M' ? 'Master'
                                                                                                            : history.key}
                                                                                        </strong>
                                                                                        <div style={{ fontSize: '0.75rem', color: '#666' }}>
                                                                                            {new Date(history.changedAt).toLocaleDateString()}
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                        ) : (
                                                                            <span style={{ color: '#999', fontSize: '0.8rem' }}>No History</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </TableCell> */}

                                                    <TableCell className="pl-3 fw-normal">
                                                        <Button
                                                            variant="outlined" style={{ backgroundColor: '#5c7a94', color: 'white', border: 'none', padding: '10px' }}
                                                            size="small"
                                                            onClick={() => {
                                                                const record = group.activityRecordsId.find(
                                                                    record => record.activityId?._id === activity.activityId?._id
                                                                );
                                                                setSelectedHistory(record?.statusHistory || []);
                                                                setOpenHistory(true);
                                                            }}
                                                        >
                                                            History
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.publicStatus === 'draft' ? (
                                                            <button
                                                                style={{
                                                                    padding: '4px 8px',
                                                                    backgroundColor: '#1976d2',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => handlePublicStatusClick(activity)}
                                                            >
                                                                Draft
                                                            </button>
                                                        ) : (
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: 'green',
                                                                    textDecoration: 'underline',
                                                                }}

                                                            >
                                                                Published
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                    {/* <TableCell className="pl-3 fw-normal">
                                                        {activity.publicStatus }
                                                    </TableCell> */}


                                                </TableRow>
                                            ))}
                                        </React.Fragment>
                                          )
                                    ))}
                            </TableBody>

                        </Table>
                                                </TableContainer >

                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 1000000]}
                            count={activityListcount}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    width: '460px', // set custom width
                    maxWidth: '80%', // optional, responsive behavior
                }
            }
            }>
                <DialogTitle>Add Activity recorder</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 508 }}>

                        <TextField InputProps={{ style: { width: 200 } }}
                            id="date"
                            name="date"
                            autoFocus
                            label="Start Date"
                            type="date"
                           // ref={formRefs.date}
                            error={formik.touched.date && Boolean(formik.errors.date)}
                            value={formik.values.date}
                            onChange={(e) => {
                                formik.handleChange(e);
                                // If end date is before new start date, clear it
                                if (formik.values.endDate && e.target.value && new Date(e.target.value) > new Date(formik.values.endDate)) {
                                    formik.setFieldValue('endDate', '');
                                }
                            }}
                            helperText={formik.touched.date && formik.errors.date}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField InputProps={{ style: { width: 200 } }}
                            id="endDate"
                            name="endDate"
                            label="End Date"
                            type="date"
                            min={formik.values.date || undefined}
                            value={formik.values.endDate}
                            onChange={(e) => {
                                const selectedEndDate = e.target.value;
                                // Only allow if end date is greater than or equal to start date
                                if (!formik.values.date || new Date(selectedEndDate) >= new Date(formik.values.date)) {
                                    formik.handleChange(e);
                                } else {
                                    // Show error or prevent selection
                                    alert('End date must be greater than or equal to start date');
                                }
                            }}
                            error={formik.touched.endDate && Boolean(formik.errors.endDate) || (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date))}
                            helperText={
                                formik.touched.endDate && formik.errors.endDate 
                                    ? formik.errors.endDate 
                                    : (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date) 
                                        ? 'End date must be >= start date' 
                                        : '')
                            }
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <FormControl className={classes.formControl} style={{ width: 423 }}
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"
                                value={formik.values.classId}
                                onChange={e => { formik.handleChange(e); getStudentList(e); getAllSuperActivityTabelMultiple(e) }}
                                // onChange={formik.handleChange}
                                //value={classId}
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl variant="standard" style={{ width: 423 }}>
                            <InputLabel id="studentName-label">Student Name</InputLabel>
                            <Select
                                labelId="studentName-label"
                                id="studentName-select"
                                label="Student Name"
                                name="studentId"
                                multiple
                                disabled={formik.values.isEdit}
                                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                                onChange={formik.handleChange}
                                // Customize how the selected values are displayed in the input
                                renderValue={(selected) => {
                                    // Find student names for the selected IDs
                                    const selectedNames = studentList
                                        .filter(({ _id }) => selected.includes(_id))
                                        .map(({ studentName }) => studentName);
                                    return selectedNames.join(", ");
                                }}
                            >
                                {studentList.map(({ _id, studentName }) => (
                                    <MenuItem key={_id} value={_id}>
                                        {studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <div>

                            {formik.values.isEventForAllStudent}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isEventForAllStudent" id="terms"
                                            value={formik.values.isEventForAllStudent}
                                            checked={formik.values.isEventForAllStudent}
                                            onChange={formik.handleChange}
                                            error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                                            helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                                        />
                                    }
                                    label="For All Class Students"
                                />
                            </Grid>


                        </div>
                        {formik.values.isEdit ? (
                            // Show three-level select boxes when editing
                            <>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="superActivityName"
                                        label="Area Of Work "
                                        name="superActivityId"
                                        onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                        value={formik.values.superActivityId}
                                        error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                        helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="activityName"
                                        label="List Of Activities"
                                        name="activityId"
                                        onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                        value={formik.values.activityId}
                                        error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                        helperText={formik.touched.activityId && formik.errors.activityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addActivityList.map(({ _id, activityName }) => (
                                            <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="subActivityName">Exercise</InputLabel>
                                    <Select
                                        labelId="subActivityName"
                                        id="subActivityId"
                                        label="Exercise"
                                        name="subActivityId"
                                        value={formik.values.subActivityId}
                                        onChange={formik.handleChange}
                                        error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                        helperText={formik.touched.subActivityId && formik.errors.subActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {subActivityList.map(({ _id, subActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{subActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            // Show tree structure when adding new
                            <>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="search-activities"
                                    label="Search Activities"
                                    type="text"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ marginBottom: '20px' }}
                                    InputProps={{
                                        startAdornment: (
                                            <span style={{ marginRight: '8px' }}>🔍</span>
                                        ),
                                        style: { width: 423 }
                                    }}
                                />
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                >
                                    {selectedActivities.map((node) => renderTree(node))}
                                </TreeView>
                            </>
                        )}
                        {/* <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="superActivityName"
                                label="Area Of Work "
                                name="superActivityId"
                                onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                value={formik.values.superActivityId}
                                error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addSuperActivityList.map(({ _id, superActivityName }) => (

                                    <MenuItem key={_id} value={_id}>{superActivityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                label="List Of Activities"
                                name="activityId"
                                onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                value={formik.values.activityId}
                                error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                helperText={formik.touched.activityId && formik.errors.activityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addActivityList.map(({ _id, activityName }) => (

                                    <MenuItem key={_id} value={_id}>{activityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="subActivityName">Exercise</InputLabel>
                            <Select
                                labelId="subActivityName"
                                id="subActivityId"
                                label="Exercise"
                                name="subActivityId"
                                value={formik.values.subActivityId}
                                onChange={formik.handleChange}
                                error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                helperText={formik.touched.subActivityId && formik.errors.subActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {subActivityList.map(({ _id, subActivityName }) => (
                                    <MenuItem key={_id} value={_id}>{subActivityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                        <FormControl variant="standard" style={{ width: 423 }}>
                            <InputLabel id="demo-simple-select-standard-label">Select Key</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Key"
                                name="key"
                                value={formik.values.key}
                                onChange={formik.handleChange}
                                error={formik.touched.key && Boolean(formik.errors.key)}
                                helperText={formik.touched.key && formik.errors.key}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {keyOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>

                                ))}
                            </Select>
                        </FormControl>
                        <TextField InputProps={{ style: { width: 423 } }}
                            margin="dense"
                            id="remarks"
                            name="remarks"
                            label="Remarks"
                            type="text"
                            variant="standard"
                            value={formik.values.remarks}
                            onChange={formik.handleChange}
                            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                            helperText={formik.touched.remarks && formik.errors.remarks}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" onClick={verifyeetnt}>Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog open={openHistory} onClose={() => setOpenHistory(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Key Status History</DialogTitle>
                <DialogContent dividers style={{ maxHeight: '300px' }}>
                    {selectedHistory.length > 0 ? (
                        selectedHistory
                            .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt))
                            .map((history, index) => (
                                <div
                                    key={index}
                                    style={{
                                        background: '#f1f5f8',
                                        borderRadius: '6px',
                                        padding: '8px',
                                        marginBottom: '8px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <strong>
                                        {history.key === 'P'
                                            ? 'Presented'
                                            : history.key === 'WI'
                                                ? 'Work Independently'
                                                : history.key === 'WA'
                                                    ? 'Work with Assistance'
                                                    : history.key === 'M'
                                                        ? 'Mastered'
                                                        : history.key}
                                    </strong>
                                    <div style={{ fontSize: '0.75rem', color: '#555' }}>
                                        {new Date(history.changedAt).toLocaleDateString()}
                                    </div>
                                </div>
                            ))
                    ) : (
                        <div style={{ color: '#999', fontSize: '0.85rem' }}>No history available.</div>
                    )}
                </DialogContent>
            </Dialog>

        </>
    );
}


